import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";

export default function ArticleSection() {
  const latest = articles.slice(0, 6);
  return (
    <section className="py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <h2 className="font-heading text-2xl text-foreground-900 md:text-3xl">最新动漫资讯</h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">新番前瞻、经典盘点、深度评测，每天更新精彩内容</p>
          </div>
          <Link to="/article" className="inline-flex items-center whitespace-nowrap text-sm font-medium text-primary-600 transition hover:text-primary-700">
            全部资讯 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {latest.map((a) => (
            <ArticleCard key={a.id} article={a} />
          ))}
        </div>
      </div>
    </section>
  );
}